import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

interface ActivityChartData {
  date: string;
  count: number;
}

interface ActivitiesChartProps {
  data: ActivityChartData[];
}

const ActivitiesChart: React.FC<ActivitiesChartProps> = ({ data }) => {
  // Custom tooltip
  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      return (
        <div className="dashboard-chart-tooltip">
          <p className="dashboard-chart-tooltip-label">{payload[0].payload.date}</p>
          {payload.map((entry: any, index: number) => (
            <p key={index} className="dashboard-chart-tooltip-value" style={{ color: entry.color }}>
              {entry.name}: {entry.value}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="dashboard-chart-wrapper">
      <ResponsiveContainer width="100%" height={400}>
        <LineChart
          data={data}
          margin={{ top: 20, right: 30, left: 20, bottom: 60 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
          <XAxis
            dataKey="date"
            angle={-45}
            textAnchor="end"
            height={80}
            tick={{ fill: '#666666', fontSize: 12 }}
          />
          <YAxis
            tick={{ fill: '#666666', fontSize: 12 }}
            label={{ value: 'Activities', angle: -90, position: 'insideLeft', fill: '#666666' }}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          <Line 
            type="monotone" 
            dataKey="count" 
            stroke="#333333" 
            strokeWidth={2}
            name="Activities"
            dot={{ fill: '#333333', r: 4 }}
            activeDot={{ r: 6 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ActivitiesChart;

